// extracted by mini-css-extract-plugin
export default {"menu-list":"HeaderMenu_menu-list__P6TbC","menu-list__submenu":"HeaderMenu_menu-list__submenu__jdiNR"};